export enum PermissionsEnum {
  ///* ADD ---------------------------
  api_add_agendamiento = 'api.add_agendamiento',
  api_add_bodega = 'api.add_bodega',
  api_add_ciudad = 'api.add_ciudad',
  api_add_cliente = 'api.add_cliente',
  api_add_codigootp = 'api.add_codigootp',
  api_add_contrato = 'api.add_contrato',
  api_add_egresoinventario = 'api.add_egresoinventario',
  api_add_flota = 'api.add_flota',
  api_add_formapago = 'api.add_formapago',
  api_add_ingresoinventario = 'api.add_ingresoinventario',
  api_add_instalacion = 'api.add_instalacion',
  api_add_iva = 'api.add_iva',
  api_add_solicitudcorporativa = 'api.add_solicitudcorporativa',
  api_add_responsable = 'api.add_responsable',
  api_add_movimientoinventario = 'api.add_movimientoinventario',
  api_add_nap = 'api.add_nap',
  api_add_nodo = 'api.add_nodo',
  api_add_operadora = 'api.add_operadora',
  api_add_olt = 'api.add_olt',
  api_add_radius = 'api.add_radius',
  api_add_ipv4 = 'api.add_ipv4',
  api_add_cajaprimaria = 'api.add_cajaprimaria',
  api_add_ordentrabajo = 'api.add_ordentrabajo',
  api_add_pais = 'api.add_pais',
  api_add_parroquia = 'api.add_parroquia',
  api_add_plan = 'api.add_plan',
  api_add_preagendamiento = 'api.add_preagendamiento',
  api_add_preventa = 'api.add_preventa',
  api_add_producto = 'api.add_producto',
  api_add_profile = 'api.add_profile',
  api_add_promocion = 'api.add_promocion',
  api_add_prospecto = 'api.add_prospecto',
  api_add_provincia = 'api.add_provincia',
  api_add_radiobase = 'api.add_radiobase',
  api_add_router = 'api.add_router',
  api_add_sector = 'api.add_sector',
  api_add_servicio = 'api.add_servicio',
  api_add_solicituddesbloqueo = 'api.add_solicituddesbloqueo',
  api_add_trasladoinventario = 'api.add_trasladoinventario',
  api_add_ubicacion = 'api.add_ubicacion',
  api_add_ubicacionproducto = 'api.add_ubicacionproducto',
  api_add_zona = 'api.add_zona',
  api_add_area = 'api.add_area',
  api_add_departamento = 'api.add_departamento',
  api_add_entidadfinanciera = 'api.add_entidadfinanciera',
  api_add_grupoipv4 = 'api.add_grupoipv4',
  api_add_grupoipv6 = 'api.add_grupoipv6',
  api_add_planificador = 'api.add_planificador',
  api_add_empresa = 'api.add_empresa',
  api_add_nodos = 'api.add_nodos',
  api_add_modelo = 'api.add_modelo',
  api_add_ticket_soporte = 'api.add_ticketsoporte',
  api_add_categoria_producto = 'api.add_categoriaproducto',
  api_add_marca_producto = 'api.add_marca',
  api_add_proveedor = 'api.add_proveedor',
  api_add_compra = 'api.add_compra',
  api_add_tipo_compras = 'api.add_tipo_compras',
  api_add_ordencompra = 'api.add_ordencompra',
  api_add_grupo_proveedores = 'api.add_grupo_proveedores',
  api_add_tipocomprobante = 'api.add_tipocomprobante',
  api_add_servicios = 'api.add_servicios',
  api_add_solicitudes_compra = 'api.add_solicitudes_compra',
  api_add_solicitudes_compra_bodega = 'api.add_solicitudes_compra_bodega',
  api_add_cargo_empleado = 'api.add_cargo_empleado',
  api_add_subcategoriaproducto = 'api.add_subcategoriaproducto',
  api_add_centrocosto = 'api.add_centrocosto',
  api_add_activo = 'api.add_activo',
  api_add_tiporegimen = 'api.add_tiporegimen',
  api_add_canalventa = 'api.add_canalventa',
  api_add_costo = 'api.add_costo',
  api_add_formapagoproveedor = 'api.add_formapagoproveedor',
  api_add_rubro = 'api.add_rubro',
  api_add_parametro = 'api.add_parametro',
  api_add_solicitudnocobroinstalacion = 'api.add_solicitudnocobroinstalacion',
  api_add_asignacionactivo = "api.add_asignacionactivo",
  api_add_cargo = "api.add_cargo",
  api_add_empleado = 'api.add_empleado',
  api_add_gasto = 'api.add_gasto',
  api_add_grupoactivo = "api.add_grupoactivo",
  api_add_ice = 'api.add_ice',
  api_add_mantenimientoactivo = 'api.add_mantenimientoactivo',
  api_add_motivo = 'api.add_motivo',
  api_add_motivorechazo = 'api.add_motivorechazo',
  api_add_porcentajeretivabienes = 'api.add_porcentajeretivabienes',
  api_add_porcentajeretivaservicios = "api.add_porcentajeretivaservicios",
  api_add_presentacion = 'api.add_presentacion',
  api_add_solicitudegreso = 'api.add_solicitudegreso',
  api_add_solicitudingreso = 'api.add_solicitudingreso',
  api_add_tarjeta = 'api.add_tarjeta',
  api_add_ticketuser = 'api.add_ticketuser',
  api_add_unidadmedida = 'api.add_unidadmedida',
  api_add_unidadtransporte = 'api.add_unidadtransporte',
  api_add_solicitudpasardeuda = 'api.add_solicitudpasardeuda',
  api_add_plancoorporativo = 'api.add_plancoorporativo',
  api_add_factibilidadcoorporativa = 'api.add_factibilidadcoorporativa',
  api_add_solicitudextrangeroprospecto = 'api.add_solicitudextrangeroprospecto',
  api_add_prospectocorporativo = 'api.add_prospectocorporativo',
  api_add_preventacoorporativa = 'api.add_preventacoorporativa',
  api_add_agendacorporativa = 'api.add_agendacorporativa',
  api_add_solicitudevento = 'api.add_solicitudevento',
  api_add_solicitudcanje = 'api.add_solicitudcanje',
  api_add_solicitudaplicagremios = 'api.add_solicitudaplicagremios',
  api_add_analisistrabajoseguro = 'api.add_analisistrabajoseguro',
  api_add_preagendamientopymes = "api.add_preagendamientopymes",
  api_add_preventapymes = "api.add_preventapymes",
  api_add_prospectopymes = "api.add_prospectopymes",
  api_add_solicituddesbloqueopymes = "api.add_solicituddesbloqueopymes",
  api_add_facturaordencompragasto = "api.add_facturaordencompragasto",
  api_add_factura = "api.add_factura",
  api_add_serviciodigital = "api.add_serviciodigital",
  api_add_auditorialog = "api.add_auditorialog",
  api_add_ordenserviciotraslado = "api.view_ordenserviciotraslado",
  api_add_ordenservicio = "api.add_ordenservicio",
  api_add_notificacioninventario = "api.add_notificacioninventario",
  api_add_configuraciontransito = "api.add_configuraciontransito",

  // api_add_radius = 'api.add_radius',

  ///* CHANGE ---------------------------
  api_change_agendamiento = 'api.change_agendamiento',
  api_change_bodega = 'api.change_bodega',
  api_change_ciudad = 'api.change_ciudad',
  api_change_cliente = 'api.change_cliente',
  api_change_codigootp = 'api.change_codigootp',
  api_change_contrato = 'api.change_contrato',
  api_change_egresoinventario = 'api.change_egresoinventario',
  api_change_fidelizacion = 'api.change_fidelizacion',
  api_change_flota = 'api.change_flota',
  api_change_formapago = 'api.change_formapago',
  api_change_ingresoinventario = 'api.change_ingresoinventario',
  api_change_instalacion = 'api.change_instalacion',
  api_change_migracion = 'api.change_migracion',
  api_change_iva = 'api.change_iva',
  api_change_observacion = 'api.change_observacion',
  api_change_responsable = 'api.change_responsable',
  api_change_movimientoinventario = 'api.change_movimientoinventario',
  api_change_nap = 'api.change_nap',
  api_change_nodo = 'api.change_nodo',
  api_change_operadora = 'api.change_operadora',
  api_change_olt = 'api.change_olt',
  api_change_cajaprimaria = 'api.change_cajaprimaria',
  api_change_ordentrabajo = 'api.change_ordentrabajo',
  api_change_pais = 'api.change_pais',
  api_change_parroquia = 'api.change_parroquia',
  api_change_plan = 'api.change_plan',
  api_change_preagendamiento = 'api.change_preagendamiento',
  api_change_preventa = 'api.change_preventa',
  api_change_producto = 'api.change_producto',
  api_change_ticket_soporte = 'api.change_ticketsoporte',
  api_change_profile = 'api.change_profile',
  api_change_promocion = 'api.change_promocion',
  api_change_prospecto = 'api.change_prospecto',
  api_change_provincia = 'api.change_provincia',
  api_change_radiobase = 'api.change_radiobase',
  api_change_router = 'api.change_router',
  api_change_sector = 'api.change_sector',
  api_change_servicio = 'api.change_servicio',
  api_change_solicituddesbloqueo = 'api.change_solicituddesbloqueo',
  api_change_trasladoinventario = 'api.change_trasladoinventario',
  api_change_ubicacion = 'api.change_ubicacion',
  api_change_ubicacionproducto = 'api.change_ubicacionproducto',
  api_change_zona = 'api.change_zona',
  api_change_area = 'api.change_area',
  api_change_departamento = 'api.change_departamento',
  api_change_entidadfinanciera = 'api.change_entidadfinanciera',
  api_change_grupoipv4 = 'api.change_grupoipv4',
  api_change_grupoipv6 = 'api.change_grupoipv6',
  api_change_planificador = 'api.change_planificador',
  api_change_empresa = 'api.change_empresa',
  api_change_nodos = 'api.change_nodos',
  api_change_modelo = 'api.change_modelo',
  api_change_categoria_producto = 'api.change_categoriaproducto',
  api_change_marca_producto = 'api.change_marca',
  api_change_proveedor = 'api.change_proveedor',
  api_change_compra = 'api.change_compra',
  api_change_tipo_compras = 'api.change_tipo_compras',
  api_change_ordencompra = 'api.change_ordencompra',
  api_chage_grupo_proveedores = 'api.chage_grupo_proveedores',
  api_change_servicios = 'api.change_servicios',
  api_change_solicitudes_compra = 'api.change_solicitudes_compra',
  api_change_tipocomprobante = 'api.change_tipocomprobante',
  api_change_radius = 'api.change_radius',
  api_change_ipv4 = 'api.change_ipv4',
  api_change_solicitudes_compra_bodega = 'api.change_solicitudes_compra_bodega',
  api_change_cargo_empleado = 'api.change_cargo_empleado',
  api_change_subcategoriaproducto = 'api.change_subcategoriaproducto',
  api_change_centrocosto = 'api.change_centrocosto',
  api_change_activo = 'api.change_activo',
  api_change_tiporegimen = 'api.change_tiporegimen',
  api_change_canalventa = 'api.change_canalventa',
  api_change_rubro = 'api.change_rubro',
  api_change_parametro = 'api.change_parametro',
  api_change_solicitudnocobroinstalacion = 'api.change_solicitudnocobroinstalacion',
  api_change_asignacionactivo = "api.change_asignacionactivo",
  api_change_cargo = "api.change_cargo",
  api_change_empleado = 'api.change_empleado',
  api_change_gasto = 'api.change_gasto',
  api_change_grupoactivo = "api.change_grupoactivo",
  api_change_ice = 'api.change_ice',
  api_change_mantenimientoactivo = 'api.change_mantenimientoactivo',
  api_change_motivo = 'api.change_motivo',
  api_change_motivorechazo = 'api.change_motivorechazo',
  api_change_porcentajeretivabienes = 'api.change_porcentajeretivabienes',
  api_change_porcentajeretivaservicios = 'api.change_porcentajeretivaservicios',
  api_change_presentacion = 'api.change_presentacion',
  api_change_solicitudegreso = 'api.change_solicitudegreso',
  api_change_solicitudingreso = 'api.change_solicitudingreso',
  api_change_tarjeta = 'api.change_tarjeta',
  api_change_ticketuser = 'api.change_ticketuser',
  api_change_unidadmedida = 'api.change_unidadmedida',
  api_change_unidadtransporte = 'api.change_unidadtransporte',
  api_change_costo = 'api.change_costo',
  api_change_formapagoproveedor = 'api.change_formapagoproveedor',
  api_change_solicitudpasardeuda = 'api.change_solicitudpasardeuda',
  api_change_plancoorporativo = 'api.change_plancoorporativo',
  api_change_factibilidadcoorporativa = 'api.change_factibilidadcoorporativa',
  api_change_preventacoorporativa = 'api.change_preventacoorporativa',
  api_change_prospectocorporativo = 'api.change_prospectocorporativo',
  api_change_solicitudextrangeroprospecto = 'api.change_solicitudextrangeroprospecto',
  api_change_agendacorporativa = 'api.change_agendacorporativa',
  api_change_solicitudcanje = 'api.change_solicitudcanje',
  api_change_solicitudevento = 'api.change_solicitudevento',
  api_change_solicitudaplicagremios = 'api.change_solicitudaplicagremios',
  api_change_solicitudcorporativa = 'api.change_solicitudcorporativa',
  api_change_analisistrabajoseguro = 'api.change_analisistrabajoseguro',
  api_change_preagendamientopymes = "api.change_preagendamientopymes",
  api_change_preventapymes = "api.change_preventapymes",
  api_change_prospectopymes = "api.change_prospectopymes",
  api_change_solicituddesbloqueopymes = "api.change_solicituddesbloqueopymes",
  api_change_facturaordencompragasto = "api.change_facturaordencompragasto",
  api_change_factura = "api.change_factura",
  api_change_serviciodigital = "api.change_serviciodigital",
  api_change_auditorialog = "api.change_auditorialog",
  api_change_ordenserviciotraslado = "api.change_ordenserviciotraslado",
  api_change_ordenservicio = "api.change_ordenservicio",
  api_change_configuraciontransito = "api.change_configuraciontransito",
  api_change_gestioninventariocuadre = "api.change_gestioninventariocuadre",
  api_change_reingresoserie = "api.change_reingresoserie",
  api_change_notificacioninventario = "api.change_notificacioninventario",

  ///* DELETE ---------------------------
  api_delete_agendamiento = 'api.delete_agendamiento',
  api_delete_bodega = 'api.delete_bodega',
  api_delete_ciudad = 'api.delete_ciudad',
  api_delete_cliente = 'api.delete_cliente',
  api_delete_codigootp = 'api.delete_codigootp',
  api_delete_contrato = 'api.delete_contrato',
  api_delete_egresoinventario = 'api.delete_egresoinventario',
  api_delete_flota = 'api.delete_flota',
  api_delete_formapago = 'api.delete_formapago',
  api_delete_ingresoinventario = 'api.delete_ingresoinventario',
  api_delete_instalacion = 'api.delete_instalacion',
  api_delete_iva = 'api.delete_iva',
  api_delete_observacion = 'api.delete_observacion',
  api_delete_responsablev2 = 'api.delete_responsable',
  api_delete_movimientoinventario = 'api.delete_movimientoinventario',
  api_delete_nap = 'api.delete_nap',
  api_delete_nodo = 'api.delete_nodo',
  api_delete_operadora = 'api.delete_operadora',
  api_delete_olt = 'api.delete_olt',
  api_delete_ordentrabajo = 'api.delete_ordentrabajo',
  api_delete_pais = 'api.delete_pais',
  api_delete_parroquia = 'api.delete_parroquia',
  api_delete_plan = 'api.delete_plan',
  api_delete_preagendamiento = 'api.delete_preagendamiento',
  api_delete_preventa = 'api.delete_preventa',
  api_delete_producto = 'api.delete_producto',
  api_delete_profile = 'api.delete_profile',
  api_delete_promocion = 'api.delete_promocion',
  api_delete_ticket_soporte = 'api.delete_ticketsoporte',
  api_delete_prospecto = 'api.delete_prospecto',
  api_delete_provincia = 'api.delete_provincia',
  api_delete_radiobase = 'api.delete_radiobase',
  api_delete_router = 'api.delete_router',
  api_delete_sector = 'api.delete_sector',
  api_delete_servicio = 'api.delete_servicio',
  api_delete_solicituddesbloqueo = 'api.delete_solicituddesbloqueo',
  api_delete_trasladoinventario = 'api.delete_trasladoinventario',
  api_delete_ubicacion = 'api.delete_ubicacion',
  api_delete_ubicacionproducto = 'api.delete_ubicacionproducto',
  api_delete_zona = 'api.delete_zona',
  api_delete_area = 'api.delete_area',
  api_delete_departamento = 'api.delete_departamento',
  api_delete_entidadfinanciera = 'api.delete_entidadfinanciera',
  api_delete_grupoipv4 = 'api.delete_grupoipv4',
  api_delete_grupoipv6 = 'api.delete_grupoipv6',
  api_delete_planificador = 'api.delete_planificador',
  api_delete_empresa = 'api.delete_empresa',
  api_delete_modelo = 'api.delete_modelo',
  api_delete_categoria_producto = 'api.delete_categoriaproducto',
  api_delete_marca_producto = 'api.delete_marca',
  api_delete_proveedor = 'api.delete_proveedor',
  api_delete_compra = 'api.delete_compra',
  api_delete_tipo_compras = 'api.delete_tipo_compras',
  api_delete_ordencompra = 'api.delete_ordencompra',
  api_delete_grupo_proveedores = 'api.delete_grupo_proveedores',
  api_delete_servicios = 'api.delete_servicios',
  api_delete_solicitudes_compra = 'api.delete_solicitudes_compra',
  api_delete_tipocomprobante = 'api.delete_tipocomprobante',
  api_delete_solicitudes_compra_bodega = 'api.delete_solicitudes_compra_bodega',
  api_delete_cargo_empleado = 'api.delete_cargo_empleado',
  api_delete_subcategoriaproducto = 'api.delete_subcategoriaproducto',
  api_delete_centro = 'api.delete_centro',
  api_delete_activo = 'api.delete_activo',
  api_delete_tiporegimen = 'api.delete_tiporegimen',
  api_delete_canalventa = 'api.delete_canalventa',
  api_delete_rubro = 'api.delete_rubro',
  api_delete_parametro = 'api.delete_parametro',
  api_delete_solicitudnocobroinstalacion = 'api.delete_solicitudnocobroinstalacion',
  api_delete_asignacionactivo = "api.delete_asignacionactivo",
  api_delete_cargo = "api.delete_cargo",
  api_delete_empleado = 'api.delete_empleado',
  api_delete_gasto = 'api.delete_gasto',
  api_delete_grupoactivo = "api.delete_grupoactivo",
  api_delete_ice = 'api.delete_ice',
  api_delete_mantenimientoactivo = 'api.delete_mantenimientoactivo',
  api_delete_motivo = 'api.delete_motivo',
  api_delete_motivorechazo = 'api.delete_motivorechazo',
  api_delete_porcentajeretivabienes = 'api.delete_porcentajeretivabienes',
  api_delete_porcentajeretivaservicios = 'api.delete_porcentajeretivaservicios',
  api_delete_presentacion = 'api.delete_presentacion',
  api_delete_solicitudegreso = 'api.delete_solicitudegreso',
  api_delete_solicitudingreso = 'api.delete_solicitudingreso',
  api_delete_tarjeta = 'api.delete_tarjeta',
  api_delete_ticketuser = 'api.delete_ticketuser',
  api_delete_unidadmedida = 'api.delete_unidadmedida',
  api_delete_unidadtransporte = 'api.delete_unidadtransporte',
  api_delete_costo = 'api.delete_costo',
  api_delete_formapagoproveedor = 'api.delete_formapagoproveedor',
  api_delete_solicitudpasardeuda = 'api.delete_solicitudpasardeuda',
  api_delete_solicitudextrangeroprospecto = 'api.delete_solicitudextrangeroprospecto',
  api_delete_plancoorporativo = 'api.delete_plancoorporativo',
  api_delete_factibilidadcoorporativa = 'api.delete_factibilidadcoorporativa',
  api_delete_solicitudcanje = 'api.delete_solicitudcanje',
  api_delete_solicitudevento = 'api.delete_solicitudevento',
  api_delete_solicitudaplicagremios = 'api.delete_solicitudaplicagremios',
  api_delete_analisistrabajoseguro = 'api.delete_analisistrabajoseguro',
  api_delete_preagendamientopymes = "api.delete_preagendamientopymes",
  api_delete_preventapymes = "api.delete_preventapymes",
  api_delete_prospectopymes = "api.delete_prospectopymes",
  api_delete_solicituddesbloqueopymes = "api.delete_solicituddesbloqueopymes",
  api_delete_facturaordencompragasto = "api.delete_facturaordencompragasto",
  api_delete_factura = "api.delete_factura",
  api_delete_auditorialog = "api.delete_auditorialog",
  api_delete_ordenserviciotraslado = "api.delete_ordenserviciotraslado",
  api_delete_ordenservicio = "api.delete_ordenservicio",
  api_delete_notificacioninventario = "api.delete_notificacioninventario",

  // // // // VIEW ---------------------------
  api_view_agendamiento = 'api.view_agendamiento',
  api_view_bodega = 'api.view_bodega',
  api_view_ciudad = 'api.view_ciudad',
  api_view_cliente = 'api.view_cliente',
  api_view_codigootp = 'api.view_codigootp',
  api_view_contrato = 'api.view_contrato',
  api_view_egresoinventario = 'api.view_egresoinventario',
  api_view_solicitudingreso = 'api.view_solicitudingreso',
  api_view_fidelizacion = 'api.view_fidelizacion',
  api_view_flota = 'api.view_flota',
  api_view_formapago = 'api.view_formapago',
  api_view_ingresoinventario = 'api.view_ingresoinventario',
  api_view_instalacion = 'api.view_instalacion',
  api_view_migracion = 'api.view_migracion',
  api_view_iva = 'api.view_iva',
  api_view_solicitudcorporativa = 'api.view_solicitudcorporativa',
  api_view_movimientoinventario = 'api.view_movimientoinventario',
  api_view_nap = 'api.view_nap',
  api_view_nodo = 'api.view_nodo',
  api_view_operadora = 'api.view_operadora',
  api_view_olt = 'api.view_olt',
  api_view_ipv4 = 'api.view_ipv4',
  api_view_radius = 'api.view_radius',
  api_view_ordentrabajo = 'api.view_ordentrabajo',
  api_view_pais = 'api.view_pais',
  api_view_parroquia = 'api.view_parroquia',
  api_view_plan = 'api.view_plan',
  api_view_preagendamiento = 'api.view_preagendamiento',
  api_view_preventa = 'api.view_preventa',
  api_view_producto = 'api.view_producto',
  api_view_profile = 'api.view_profile',
  api_view_promocion = 'api.view_promocion',
  api_view_prospecto = 'api.view_prospecto',
  api_view_provincia = 'api.view_provincia',
  api_view_radiobase = 'api.view_radiobase',
  api_view_router = 'api.view_router',
  api_view_sector = 'api.view_sector',
  api_view_servicio = 'api.view_servicio',
  api_view_solicitudingresobeneficio = 'api.view_solicitudingresobeneficio',
  api_view_solicituddesbloqueo = 'api.view_solicituddesbloqueo',
  api_view_trasladoinventario = 'api.view_trasladoinventario',
  api_view_ubicacion = 'api.view_ubicacion',
  api_view_ubicacionproducto = 'api.view_ubicacionproducto',
  api_view_zona = 'api.view_zona',
  api_view_area = 'api.view_area',
  api_view_departamento = 'api.view_departamento',
  api_view_entidadfinanciera = 'api.view_entidadfinanciera',
  api_view_grupoipv4 = 'api.view_grupoipv4',
  api_view_grupoipv6 = 'api.view_grupoipv6',
  api_view_planificador = 'api.view_planificador',
  api_view_empresa = 'api.view_empresa',
  api_view_modelo = 'api.view_modelo',
  api_view_categoria_producto = 'api.view_categoriaproducto',
  api_view_ticket_soporte = 'api.view_ticketsoporte',
  api_view_marca_producto = 'api.view_marca',
  api_view_proveedor = 'api.view_proveedor',
  api_view_compra = 'api.view_compra',
  api_view_tipo_compras = 'api.view_tipo_compras',
  api_view_ordencompra = 'api.view_ordencompra',
  api_view_grupo_proveedores = 'api.view_grupo_proveedores',
  api_view_servicios = 'api.view_servicios',
  api_view_tipocomprobante = 'api.view_tipocomprobante',
  api_view_solicitudes_compra = 'api.view_solicitudes_compra',
  api_view_solicitudes_compra_bodega = 'api.view_solicitudes_compra_bodega',
  api_view_cargo_empleado = 'api.view_cargo_empleado',
  api_view_subcategoriaproducto = 'api.view_subcategoriaproducto',
  api_view_centrocosto = 'api.view_centrocosto',
  api_view_activo = 'api.view_activo',
  api_view_tiporegimen = 'api.view_tiporegimen',
  api_view_canalventa = 'api.view_canalventa',
  api_view_rubro = 'api.view_rubro',
  api_view_parametro = 'api.view_parametro',
  api_view_solicitudnocobroinstalacion = 'api.view_solicitudnocobroinstalacion',
  api_view_asignacionactivo = "api.view_asignacionactivo",
  api_view_cargo = "api.view_cargo",
  api_view_empleado = 'api.view_empleado',
  api_view_gasto = 'api.view_gasto',
  api_view_grupoactivo = "api.view_grupoactivo",
  api_view_ice = 'api.view_ice',
  api_view_mantenimientoactivo = 'api.view_mantenimientoactivo',
  api_view_motivo = 'api.view_motivo',
  api_view_motivorechazo = 'api.view_motivorechazo',
  api_view_porcentajeretivabienes = 'api.view_porcentajeretivabienes',
  api_view_porcentajeretivaservicios = 'api.view_porcentajeretivaservicios',
  api_view_presentacion = 'api.view_presentacion',
  api_view_solicitudegreso = 'api.view_solicitudegreso',
  api_view_tarjeta = 'api.view_tarjeta',
  api_view_ticketuser = 'api.view_ticketuser',
  api_view_unidadmedida = 'api.view_unidadmedida',
  api_view_unidadtransporte = 'api.view_unidadtransporte',
  api_view_costo = 'api.view_costo',
  api_view_formapagoproveedor = 'api.view_formapagoproveedor',
  api_view_solicitudpasardeuda = 'api.view_solicitudpasardeuda',
  api_view_plancoorporativo = 'api.view_plancoorporativo',
  api_view_solicitudextrangeroprospecto = 'api.view_solicitudextrangeroprospecto',
  api_view_trazocorporativo = 'api.view_trazocorporativo',
  api_view_prospectocorporativo = 'api.view_prospectocorporativo',
  api_view_factibilidadcoorporativa = 'api.view_factibilidadcoorporativa',
  api_view_preventacoorporativa = 'api.view_preventacoorporativa',
  api_view_agendacorporativa = 'api.view_agendacorporativa',
  api_view_solicitudcanje = 'api.view_solicitudcanje',
  api_view_solicitudevento = 'api.view_solicitudevento',
  api_view_solicitudaplicagremios = 'api.view_solicitudaplicagremios',
  api_view_analisistrabajoseguro = 'api.view_analisistrabajoseguro',
  api_view_preagendamientopymes = "api.view_preagendamientopymes",
  api_view_preventapymes = "api.view_preventapymes",
  api_view_prospectopymes = "api.view_prospectopymes",
  api_view_solicituddesbloqueopymes = "api.view_solicituddesbloqueopymes",
  api_view_facturaordencompragasto = "api.view_facturaordencompragasto",
  api_view_factura = "api.view_factura",
  api_view_serviciodigital = "api.view_serviciodigital",
  api_view_auditoriaticketsoportecorporativo = "api.view_auditoriaticketsoportecorporativo",
  api_view_auditorialog = "api.view_auditorialog",
  api_view_ordenserviciotraslado = "api.view_ordenserviciotraslado",
  api_view_ordenservicio = "api.view_ordenservicio",
  api_view_configuraciontransito = "api.view_configuraciontransito",
  api_view_gestioninventariocuadre = "api.view_gestioninventariocuadre",
  api_view_reingresoserie = "api.view_reingresoserie",
  api_view_notificacioninventario = "api.view_notificacioninventario",

  // api_view_radius = 'api.view_radius',

  ///* AUTH ---------------------------
  auth_add_group = 'auth.add_group',
  auth_add_permission = 'auth.add_permission',
  auth_add_user = 'auth.add_user',
  auth_change_group = 'auth.change_group',
  auth_change_permission = 'auth.change_permission',
  auth_change_user = 'auth.change_user',
  auth_delete_group = 'auth.delete_group',
  auth_delete_permission = 'auth.delete_permission',
  auth_delete_user = 'auth.delete_user',
  auth_view_group = 'auth.view_group',
  auth_view_permission = 'auth.view_permission',
  auth_view_user = 'auth.view_user',

  ///* AUTHTOKEN ---------------------------
  authtoken_add_token = 'authtoken.add_token',
  authtoken_add_tokenproxy = 'authtoken.add_tokenproxy',
  authtoken_change_token = 'authtoken.change_token',
  authtoken_change_tokenproxy = 'authtoken.change_tokenproxy',
  authtoken_delete_token = 'authtoken.delete_token',
  authtoken_delete_tokenproxy = 'authtoken.delete_tokenproxy',
  authtoken_view_token = 'authtoken.view_token',
  authtoken_view_tokenproxy = 'authtoken.view_tokenproxy',

  ///* CONTENTTYPES ---------------------------
  contenttypes_add_contenttype = 'contenttypes.add_contenttype',
  contenttypes_change_contenttype = 'contenttypes.change_contenttype',
  contenttypes_delete_contenttype = 'contenttypes.delete_contenttype',
  contenttypes_view_contenttype = 'contenttypes.view_contenttype',

  // // // // SESSIONS ---------------------------
  sessions_add_session = 'sessions.add_session',
  sessions_change_session = 'sessions.change_session',
  sessions_delete_session = 'sessions.delete_session',
  sessions_view_session = 'sessions.view_session',

  // // // // ADMIN ---------------------------
  admin_add_logentry = 'admin.add_logentry',
  admin_change_logentry = 'admin.change_logentry',
  admin_delete_logentry = 'admin.delete_logentry',
  admin_view_logentry = 'admin.view_logentry',

  // // // // CUSTOM ---------------------------
  pyl_administrator_permission = "api.custom.pyl_administrator_permission",
  api_enable_generate_documents = "api.custom.enable_generate_documents",
  api_aprobar_formato_fisico_ats = "api.APROBAR_FORMATO_FISICO_ATS",
  api_probar_isp_user = "api.PROBAR_ISP_USER",
  api_probar_isp_demo_user = "api.PROBAR_ISP_DEMO_USER",
  reporte_stock_actual_descargar_excel = 'api.reporte_stock_actual_descargar_excel',
  kardex_descargar_excel = 'api.kardex_descargar_excel',
  liberacion_valor_instalacion = 'api.liberacion_valor_instalacion',
  custom_plan_rrhh = 'api.custom_plan_rrhh',
  solicitud_ingreso_beneficio_ayuda_social = 'api.solicitud_ingreso_beneficio_ayuda_social',
  solicitud_ingreso_score_bajo_reportado = 'api.solicitud_ingreso_score_bajo_reportado',
  solicitud_beneficio_reportado_telco = 'api.solicitud_beneficio_reportado_telco',
  revision_contabilidad_tecnico = 'api.revision_contabilidad_tecnico',
  administrador_planta_externa_permission = 'api.custom.administrador_planta_externa_permission',
  generacion_auto_mangas = 'api.generacion_auto_mangas',
  descargar_excel_agendamientos = 'api.custom.descargar_excel_agendamientos',
  /////reporte compra
  generar_reporte_nap = 'api.generar_reporte_nap',

  ///* MFA ADMIN ---------------------------
  api_administrar_mfa = 'api.administrar_mfa',
  api_resetear_mfa_usuarios = 'api.resetear_mfa_usuarios',
  api_gestionar_politica_mfa = 'api.gestionar_politica_mfa',

  api_migraciones_bras = 'api.migraciones_bras',
  /////reporte compra 
  //api_view_reporte_compra = "api.reporte_detallado_ingreso_inventario"
  reporte_actividad_inventario_usuario = 'api.reporte_actividad_inventario_usuario',
  habilitar_regulacion_transito = 'api.habilitar_regulacion_transito',
  reversar_cuadre_inventario = 'api.reversar_cuadre_inventario',

  asociar_service_profile = 'api.asociar_service_profile',
  administration_manage_system = 'api.administration.manage_system',
  transito_inventario_excel = 'api.transito_inventario_excel',
  contrato_cargar_documentos = 'api.contrato_cargar_documentos',
  contrato_enviar_documento_consolidado = 'api.contrato_enviar_documento_consolidado',
  solicitud_tutor_descuento_accion_score_bajo = 'api.solicitudtutordescuento_accion_score_bajo',

  editar_datos_radius_cliente = 'api.editar_datos_radius_cliente',

  custom_auditoria_ordenes_noc = 'api.custom.auditoria_ordenes_noc',
}
